// extracted by mini-css-extract-plugin
module.exports = {"container":"filter_dropdown_header-module__container--1_5Ta","title":"filter_dropdown_header-module__title--2kn5N"};